import React from "react";
import { MenaVstupy, PercentaVstupy } from "../vstupneKomponenty";

export default function HypoVstupneParametre({
  typHypoteky,
  setTypHypoteky,
  suma,
  setSuma,
  hodnotazabezpecenia,
  setHodnotazabezpecenia,
  ltvMoznosti,
  setLtvMoznosti,
  jeNizkaHodnota,
  fixacia,
  setFixacia,
  fixacieRocne,
  urok,
  setUrok,
  roky,
  setRoky,
  pocetziadatelov,
  setPocetziadatelov,

  setVek2,
  setPrijem2,
  setPocetdeti2,
  setVek3,
  setPrijem3,
  setPocetdeti3,
  setVek4,
  setPrijem4,
  setPocetdeti4,
  setSpolocnadomacnost1,
  setSpolocnadomacnost2,
  setAktivnyZiadatelTab,

  zmJednotlivec,
  setZmJednotlivec,
  zmDruhyDospely,
  setZmDruhyDospely,
  zmDieta,
  setZmDieta
}) {

return (
<div className="card-section card-section--vstupne-parametre">

            <h2>Vstupné parametre hypotéky:</h2>              
              {/* RIADOK 1: Typ hypo, Výška úveru, Hodnota zabezpečenia */}
              <div className="form-group form-group--cols3 form-group--vstupne-top">

                <div className="form form--l">
                  <label className="form_label">Typ hypotéky</label>
                  <select
                    className="form_select"
                    value={typHypoteky}
                    onChange={(e) => setTypHypoteky(e.target.value)}
                  >
                    <option value="nadobudnutie">Nadobudnutie</option>
                    <option value="rekonstrukcia">Rekonštrukcia</option>
                    <option value="vystavba">Výstavba</option>
                    <option value="refinancovanie">Refinancovanie</option>
                    <option value="bezucel">Bezúčelová</option>
                  </select>
                </div>

                <div className="form form--l form--ltv">
                  <label className="form_label">Výška úveru</label>
                  <MenaVstupy
                    value={suma}
                    onChange={setSuma}
                    maxDigits={7}
                    suffix="€"
                    placeholder=" "
                  />

                  {/* MEDZIRIADOK: LTV (pod sumou) */}
                  <div className="ltv-row">
                    <span className="ltv-caption">LTV:</span>
                    <div className="ltv-group">
                      <button
                        type="button"
                        className={`ltv-btn ${ltvMoznosti === 70 ? "is-active" : ""}`}
                        onClick={() => setLtvMoznosti(70)}
                      >
                        70%
                      </button>
                      <button
                        type="button"
                        className={`ltv-btn ${ltvMoznosti === 80 ? "is-active" : ""}`}
                        onClick={() => setLtvMoznosti(80)}
                      >
                        80%
                      </button>
                      <button
                        type="button"
                        className={`ltv-btn ${ltvMoznosti === 90 ? "is-active" : ""}`}
                        onClick={() => setLtvMoznosti(90)}
                      >
                        90%
                      </button>
                    </div>
                  </div>
                </div>

                <div className="form form--l">
                  <label className="form_label">Hodnota zabezpečenia</label>
                  <MenaVstupy
                    value={hodnotazabezpecenia}
                    onChange={(v) => { setHodnotazabezpecenia(v); setLtvMoznosti(null); }}
                    maxDigits={7}
                    suffix="€"
                    placeholder=" "
                    wrapClassName="ltv-input" 
                  />
                  {jeNizkaHodnota && (
                    <div className="form_hint error">Nízka hodnota zabezpečenia</div>
                  )}
                </div>
              </div>


              {/* RIADOK 2: Fixácia, Úrok, Splatnosť, Počet žiadateľov, Počet detí */}
              <div className="form-group form-group--cols4">

                <div className="form form--s">
                  <label className="form_label">Fixácia (r)</label>
                    <select
                    className="form_select"
                    value={fixacia}
                    onChange={(e) => setFixacia(Number(e.target.value) || 0)}
                  >
                    {fixacieRocne.map((f) => (
                      <option key={f} value={f}>
                        {f}
                      </option>
                    ))}
                  </select>
                </div>

                <div className="form form--s">
                  <label className="form_label">Úrok</label>
                  <PercentaVstupy
                    value={urok}
                    onChange={setUrok}
                    maxInt={2}
                    placeholder=" "
                  />
                </div>

                <div className="form form--s">
                  <label className="form_label">Splatnosť (r)</label>
                  <input
                    type="number"
                    className="form_input"
                    value={roky}
                    onChange={e => setRoky(Math.max(0, Math.min(99, Number(e.target.value)||0)))}
                    inputMode="numeric" 
                    min="0" 
                    max="99" 
                    placeholder=" "
                  />
                </div>

                <div className="form form--s">
                  <select
                    className="form_select"
                    value={pocetziadatelov}
                    onChange={(e) => {
                      const n = Number(e.target.value);

                      setPocetziadatelov(n);

                      // reset hodnôt žiadateľov nad limit (bez zásahu do výpočtov)
                      if (n === 1) {
                        setVek2(0); setPrijem2(0); setPocetdeti2(0);
                        setVek3(0); setPrijem3(0); setPocetdeti3(0);
                        setVek4(0); setPrijem4(0); setPocetdeti4(0);
                        setSpolocnadomacnost1(false);
                        setSpolocnadomacnost2(false);
                      } else if (n === 2) {
                        setVek3(0); setPrijem3(0); setPocetdeti3(0);
                        setVek4(0); setPrijem4(0); setPocetdeti4(0);
                        setSpolocnadomacnost2(false);
                      } else if (n === 3) {
                        setVek4(0); setPrijem4(0); setPocetdeti4(0);
                        setSpolocnadomacnost2(false);
                      }

                      // ak bol otvorený tab > n, zhoď ho na n
                      setAktivnyZiadatelTab((aktualny) => (aktualny > n ? n : aktualny));
                    }}
                  >
                    <option value="" disabled hidden></option>
                    <option value={1}>1</option>
                    <option value={2}>2</option>
                    <option value={3}>3</option>
                    <option value={4}>4</option>
                  </select>
                  <label className="form_label">Počet žiadatelov</label>
                </div>

              </div>

              <div className="parametre-divider" />

              {/* RIADOK 3: Životné minimá */}

              <div className="form-group form-group--cols4">
                <h3 className="subhead">Životné minimá:</h3>

                <div className="form form--m">
                  <label className="form_label">Jeden dospelý</label>
                  <div className="input-wrap">
                    <input
                      type="number"
                      step="0.01"
                      inputMode="decimal"
                      className="form_input"
                      value={zmJednotlivec}
                      onChange={(e) => setZmJednotlivec(Number(e.target.value) || 0)}
                      placeholder=" "
                    />
                    <span className="input-suffix">€</span>
                  </div>
                </div>

                <div className="form form--m">
                  <label className="form_label">Ďalší dospelý</label>
                  <div className="input-wrap">
                    <input
                      type="number"
                      step="0.01"
                      inputMode="decimal"
                      className="form_input"
                      value={zmDruhyDospely}
                      onChange={(e) => setZmDruhyDospely(Number(e.target.value) || 0)}
                      placeholder=" "
                    />
                    <span className="input-suffix">€</span>
                  </div>
                </div>

                <div className="form form--m">
                  <label className="form_label">Dieťa</label>
                  <div className="input-wrap">
                    <input
                      type="number"
                      step="0.01"
                      inputMode="decimal"
                      className="form_input"
                      value={zmDieta}
                      onChange={(e) => setZmDieta(Number(e.target.value) || 0)}
                      placeholder=" "
                    />
                    <span className="input-suffix">€</span>
                  </div>
                </div>
                

              </div>
            </div>


);
}